export default __webpack_public_path__ + "static/desklocation03-a167a4f76ba20080c8ada8054dc08e61.png";